<template>
  <AppSelect :items="toSelectItems(ITEMS)" :label="$tt('religion.label')" />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { Religion } from '~/types';

const { tt } = useLocalization();

const ITEMS: Record<Religion, string> = {
  christianity: tt('religion.christianity'),
  islam: tt('religion.islam'),
  judaism: tt('religion.judaism'),
  hindu: tt('religion.hindu'),
  druze: tt('religion.druze'),
  other: tt('religion.other')
};
</script>